import React from "react";
import "../Styles/loadingPage.css";

const LoadingPage = () => {
  return (
    <div className="d-flex justify-content-center my-3">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingPage;
